import * as React from 'react';
import {useSelector} from 'react-redux';
import {Link as RoutedLink} from 'react-router-dom';

import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';
import {useResizeObserver} from 'shells/utils/hooks/use-resize-observer';

// @ts-expect-error
import {NutshellState} from '../../../store';

import {getUserEmail} from '../tiny-intro-selector';
import {isIOSSignup, isMobileSignup, showLoginForm} from '../utils';

import styles from './main-header.module.css';

type Props = {
    showSignupLink?: boolean;
};

export function MainHeader(props: Props) {
    const containerRef = React.useRef(null);
    const emailValue = useSelector((state: NutshellState) => getUserEmail(state));
    const [width] = useResizeObserver(containerRef.current);

    return (
        <div ref={containerRef} className={styles['main-header-container']}>
            <Link href='https://www.nutshell.com/home'>
                <img
                    src='/include/images/nutshell-logo-full-color.svg'
                    alt='nutshell logo'
                    className={styles['nutshell-logo']}
                />
            </Link>
            {!isIOSSignup() && (
                <Body size='large' color='medium'>
                    <span className={styles['login-link-pretext']}>
                        {props.showSignupLink
                            ? 'Don’t have an account?'
                            : 'Already have an account?'}
                        &nbsp;&nbsp;
                    </span>
                    <Link
                        // @ts-expect-error
                        as={RoutedLink}
                        variant='primary'
                        size='big'
                        isBold={true}
                        onClick={handleLoginClick}
                        to={{
                            pathname: props.showSignupLink ? '/signup' : '/auth',
                            search: emailValue ? `?email=${emailValue}` : undefined,
                        }}
                        className={styles['login-link']}
                    >
                        {getSignupText(Boolean(props.showSignupLink), width)}
                    </Link>
                </Body>
            )}
        </div>
    );
}

export function handleLoginClick(e: Event) {
    if (!isMobileSignup()) {
        return;
    }

    e.stopPropagation();

    showLoginForm();
}

function getSignupText(showSignupLink: boolean, width?: number | null) {
    if (!showSignupLink) {
        return 'Sign in';
    }

    // text will wrap below this width, so switch to shorter text in that case
    if (width && width > 325) {
        return 'Sign up for free trial';
    }

    return 'Sign up';
}
